import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";
import { Button, Card, Logo } from "../components/kit";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const navigate = useNavigate();
  const { user, refreshUser } = useAuth();

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0, stopped = false;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); refreshUser && refreshUser(); return; }
      } catch (e) { /* keep polling */ }
      if (attempts >= 12) { setState("timeout"); return; }
      if (!stopped) setTimeout(poll, 2000);
    };
    poll();
    return () => { stopped = true; };
  }, [sessionId]);

  const home = user?.role === "coach" ? "/coach" : "/dashboard";

  return (
    <div className="buktu-root" data-testid="payment-success-page" style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--surface-page)", padding: 24 }}>
      <Card padding="var(--space-8)" style={{ maxWidth: 460, width: "100%", textAlign: "center" }}>
        <div style={{ marginBottom: "var(--space-5)", display: "flex", justifyContent: "center" }}><Logo height={26} /></div>
        {state === "checking" && (
          <>
            <div style={{ color: "var(--buktu-green)", marginBottom: 12 }}><Loader2 size={40} className="buktu-spin" /></div>
            <h1 style={{ font: "var(--type-heading)", marginBottom: 6 }}>Confirming your payment…</h1>
            <p style={{ font: "var(--type-body-sm)", color: "var(--text-muted)" }}>This only takes a moment.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <div style={{ color: "var(--status-good)", marginBottom: 12, display: "flex", justifyContent: "center" }}><CheckCircle2 size={48} /></div>
            <h1 style={{ font: "var(--type-title)", marginBottom: 6 }}>You're subscribed!</h1>
            <p style={{ font: "var(--type-body)", color: "var(--text-muted)", marginBottom: "var(--space-6)" }}>Your plan is active. Welcome aboard.</p>
            <Button full size="lg" data-testid="payment-success-continue" onClick={() => navigate(home)}>Go to my dashboard</Button>
          </>
        )}
        {(state === "timeout" || state === "error") && (
          <>
            <div style={{ color: "var(--status-watch)", marginBottom: 12, display: "flex", justifyContent: "center" }}><AlertTriangle size={44} /></div>
            <h1 style={{ font: "var(--type-heading)", marginBottom: 6 }}>Still processing</h1>
            <p style={{ font: "var(--type-body-sm)", color: "var(--text-muted)", marginBottom: "var(--space-6)" }}>Your payment may take a little longer to confirm. Your plan will activate automatically.</p>
            <Button full variant="secondary" onClick={() => navigate(home)}>Continue to dashboard</Button>
          </>
        )}
      </Card>
      <style>{`.buktu-spin{animation:buktuspin 1s linear infinite}@keyframes buktuspin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
